import React, { useState } from "react";
import SharedHelmet from "../../Helmet";
import { SecondAds } from "../../../Ads";
const TITLE = "Calculatrice de la dose quotidienne de vitamines - Calculez vos besoins en vitamines";
const DESCRIPTION =
  "Calculatrice précise de la dose quotidienne de vitamines pour calculer vos besoins journaliers en vitamines essentielles selon l'âge et le sexe. Inclut les vitamines A, C, D, E, K et toutes les vitamines du complexe B avec des explications détaillées sur les bienfaits et les sources naturelles de chaque vitamine.";
const KEYWORDS =
  "calculatrice vitamines, dose quotidienne vitamines, besoins en vitamines, vitamine A, vitamine C, vitamine D, vitamine E, vitamine K, complexe B, thiamine B1, riboflavine B2, niacine B3, acide folique, vitamine B12, sources de vitamines, carence en vitamines";
const OG_URL = "https://do-calculate.com/calculator/fr/vitamin-daily-dose/";
const vitaminsList = {
  A: "Vitamine A",
  C: "Vitamine C",
  D: "Vitamine D",
  E: "Vitamine E",
  K: "Vitamine K",
  B1: "Thiamine (B1)",
  B2: "Riboflavine (B2)",
  B3: "Niacine (B3)",
  B6: "Pyridoxine (B6)",
  B9: "Acide folique (B9)",
  B12: "Cobalamine (B12)",
  B5: "Acide pantothénique (B5)",
  B7: "Biotine (B7)",
  Choline: "Choline",
};
const vitaminUnits = {
  A: "µg",
  C: "mg",
  D: "µg",
  E: "mg",
  K: "µg",
  B1: "mg",
  B2: "mg",
  B3: "mg",
  B6: "mg",
  B9: "µg",
  B12: "µg",
  B5: "mg",
  B7: "µg",
  Choline: "mg",
};
const VitaminDailyDoseCalculator = () => {
  const [selectedVitamin, setSelectedVitamin] = useState("A");
  const [age, setAge] = useState("");
  const [sex, setSex] = useState("male");
  const [isPregnant, setIsPregnant] = useState(false);
  const [isLactating, setIsLactating] = useState(false);
  const [dose, setDose] = useState(null);
  const [error, setError] = useState("");
  const getVitaminDose = (vitamin, ageValue, gender, pregnant, lactating) => {
    const dosageTable = {
      A: {
        male: { "0-6m": 400, "7-12m": 500, "1-3y": 300, "4-8y": 400, "9-13y": 600, "14-18y": 900, "19-50y": 900, "51+y": 900 },
        female: { "0-6m": 400, "7-12m": 500, "1-3y": 300, "4-8y": 400, "9-13y": 600, "14-18y": 700, "19-50y": 700, "51+y": 700 },
        pregnant: 770, lactating: 1300,
      },
      C: {
        male: { "0-6m": 40, "7-12m": 50, "1-3y": 15, "4-8y": 25, "9-13y": 45, "14-18y": 75, "19-50y": 90, "51+y": 90 },
        female: { "0-6m": 40, "7-12m": 50, "1-3y": 15, "4-8y": 25, "9-13y": 45, "14-18y": 65, "19-50y": 75, "51+y": 75 },
        pregnant: 85, lactating: 120,
      },
      D: {
        male: { "0-6m": 10, "7-12m": 10, "1-3y": 15, "4-8y": 15, "9-13y": 15, "14-18y": 15, "19-50y": 15, "51-70y": 15, "71+y": 20 },
        female: { "0-6m": 10, "7-12m": 10, "1-3y": 15, "4-8y": 15, "9-13y": 15, "14-18y": 15, "19-50y": 15, "51-70y": 15, "71+y": 20 },
        pregnant: 15, lactating: 15,
      },
      E: {
        male: { "0-6m": 4, "7-12m": 5, "1-3y": 6, "4-8y": 7, "9-13y": 11, "14-18y": 15, "19-50y": 15, "51+y": 15 },
        female: { "0-6m": 4, "7-12m": 5, "1-3y": 6, "4-8y": 7, "9-13y": 11, "14-18y": 15, "19-50y": 15, "51+y": 15 },
        pregnant: 15, lactating: 19,
      },
      K: {
        male: { "0-6m": 2, "7-12m": 2.5, "1-3y": 30, "4-8y": 55, "9-13y": 60, "14-18y": 75, "19-50y": 120, "51+y": 120 },
        female: { "0-6m": 2, "7-12m": 2.5, "1-3y": 30, "4-8y": 55, "9-13y": 60, "14-18y": 75, "19-50y": 90, "51+y": 90 },
        pregnant: 90, lactating: 90,
      },
      B1: {
        male: { "0-6m": 0.2, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.2, "19-50y": 1.2, "51+y": 1.2 },
        female: { "0-6m": 0.2, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.0, "19-50y": 1.1, "51+y": 1.1 },
        pregnant: 1.4, lactating: 1.4,
      },
      B2: {
        male: { "0-6m": 0.3, "7-12m": 0.4, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.3, "19-50y": 1.3, "51+y": 1.3 },
        female: { "0-6m": 0.3, "7-12m": 0.4, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.0, "19-50y": 1.1, "51+y": 1.1 },
        pregnant: 1.4, lactating: 1.6,
      },
      B3: {
        male: { "0-6m": 2, "7-12m": 4, "1-3y": 6, "4-8y": 8, "9-13y": 12, "14-18y": 16, "19-50y": 16, "51+y": 16 },
        female: { "0-6m": 2, "7-12m": 4, "1-3y": 6, "4-8y": 8, "9-13y": 12, "14-18y": 14, "19-50y": 14, "51+y": 14 },
        pregnant: 18, lactating: 17,
      },
      B6: {
        male: { "0-6m": 0.1, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 1.0, "14-18y": 1.3, "19-50y": 1.3, "51-70y": 1.7, "71+y": 1.7 },
        female: { "0-6m": 0.1, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 1.0, "14-18y": 1.2, "19-50y": 1.3, "51-70y": 1.5, "71+y": 1.5 },
        pregnant: 1.9, lactating: 2.0,
      },
      B9: {
        male: { "0-6m": 65, "7-12m": 80, "1-3y": 150, "4-8y": 200, "9-13y": 300, "14-18y": 400, "19-50y": 400, "51+y": 400 },
        female: { "0-6m": 65, "7-12m": 80, "1-3y": 150, "4-8y": 200, "9-13y": 300, "14-18y": 400, "19-50y": 400, "51+y": 400 },
        pregnant: 600, lactating: 500,
      },
      B12: {
        male: { "0-6m": 0.4, "7-12m": 0.5, "1-3y": 0.9, "4-8y": 1.2, "9-13y": 1.8, "14-18y": 2.4, "19-50y": 2.4, "51+y": 2.4 },
        female: { "0-6m": 0.4, "7-12m": 0.5, "1-3y": 0.9, "4-8y": 1.2, "9-13y": 1.8, "14-18y": 2.4, "19-50y": 2.4, "51+y": 2.4 },
        pregnant: 2.6, lactating: 2.8,
      },
      B5: {
        male: { "0-6m": 1.7, "7-12m": 1.8, "1-3y": 2, "4-8y": 3, "9-13y": 4, "14-18y": 5, "19-50y": 5, "51+y": 5 },
        female: { "0-6m": 1.7, "7-12m": 1.8, "1-3y": 2, "4-8y": 3, "9-13y": 4, "14-18y": 5, "19-50y": 5, "51+y": 5 },
        pregnant: 6, lactating: 7,
      },
      B7: {
        male: { "0-6m": 5, "7-12m": 6, "1-3y": 8, "4-8y": 12, "9-13y": 20, "14-18y": 25, "19-50y": 30, "51+y": 30 },
        female: { "0-6m": 5, "7-12m": 6, "1-3y": 8, "4-8y": 12, "9-13y": 20, "14-18y": 25, "19-50y": 30, "51+y": 30 },
        pregnant: 30, lactating: 35,
      },
      Choline: {
        male: { "0-6m": 125, "7-12m": 150, "1-3y": 200, "4-8y": 250, "9-13y": 375, "14-18y": 550, "19-50y": 550, "51+y": 550 },
        female: { "0-6m": 125, "7-12m": 150, "1-3y": 200, "4-8y": 250, "9-13y": 375, "14-18y": 400, "19-50y": 425, "51+y": 425 },
        pregnant: 450, lactating: 550,
      },
    };
    let ageCategory;
    const ageNum = parseInt(ageValue);
    if (ageNum < 1) {
      ageCategory = ageNum < 0.5 ? "0-6m" : "7-12m";
    } else if (ageNum <= 3) { ageCategory = "1-3y"; }
    else if (ageNum <= 8) { ageCategory = "4-8y"; }
    else if (ageNum <= 13) { ageCategory = "9-13y"; }
    else if (ageNum <= 18) { ageCategory = "14-18y"; }
    else if (ageNum <= 50) { ageCategory = "19-50y"; }
    else if (ageNum <= 70) { ageCategory = "51-70y" in dosageTable[vitamin][gender] ? "51-70y" : "51+y"; }
    else { ageCategory = "71+y" in dosageTable[vitamin][gender] ? "71+y" : "51+y"; }
    if (gender === "female" && pregnant) return dosageTable[vitamin].pregnant;
    if (gender === "female" && lactating) return dosageTable[vitamin].lactating;
    return dosageTable[vitamin][gender][ageCategory];
  };
  const calculateDailyDose = () => {
    try {
      if (!age || age < 0 || age > 120) {
        setError("Veuillez entrer un âge valide (0-120 ans)");
        setDose(null);
        return;
      }
      const calculatedDose = getVitaminDose(selectedVitamin, age, sex, isPregnant, isLactating);
      setDose(calculatedDose);
      setError("");
    } catch (err) {
      setDose(null);
      setError("Une erreur est survenue lors du calcul. Veuillez vérifier les données saisies.");
    }
  };
  const handleCalculate = (e) => {
    e.preventDefault();
    calculateDailyDose();
  };
  const handleReset = () => {
    setSelectedVitamin("A");
    setAge("");
    setSex("male");
    setIsPregnant(false);
    setIsLactating(false);
    setDose(null);
    setError("");
  };
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: "https://do-calculate.com/" },
        { "@type": "ListItem", position: 2, name: "Calculatrices", item: "https://do-calculate.com/fr/all-calculators/" },
        { "@type": "ListItem", position: 3, name: "Calculatrice vitamines", item: OG_URL },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Comment calculer mes besoins quotidiens en vitamines ?",
          acceptedAnswer: { "@type": "Answer", text: "Pour calculer vos besoins quotidiens en vitamines, entrez votre âge, choisissez votre sexe et la vitamine souhaitée dans la calculatrice. Les besoins varient selon l'âge, le sexe et l'état de santé." },
        },
        {
          "@type": "Question",
          name: "Quelles sont les vitamines les plus importantes pour l'organisme ?",
          acceptedAnswer: { "@type": "Answer", text: "Les vitamines les plus importantes incluent : la vitamine D pour les os, la vitamine C pour l'immunité, la vitamine A pour la vision, la vitamine B12 pour les nerfs, et l'acide folique surtout pour les femmes enceintes." },
        },
        {
          "@type": "Question",
          name: "Quels sont les symptômes d'une carence en vitamines ?",
          acceptedAnswer: { "@type": "Answer", text: "Les symptômes d'une carence en vitamines incluent : fatigue et épuisement, affaiblissement du système immunitaire, problèmes de peau, faiblesse osseuse, anémie, et problèmes nerveux selon le type de vitamine manquante." },
        },
      ],
    };
    return [breadcrumbSchema, faqSchema];
  };
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} SCHEMA={generateSchemaData()} />
      <div>
        <br />
        <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "12px" }}>
          <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
        </div>
        <div className="border border-light mt-3 p-3 bg-white shadow-sm">
          <div className="mb-4">
            <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
              La <strong>calculatrice de la dose quotidienne de vitamines</strong> vous aide à connaître vos besoins journaliers en vitamines essentielles selon votre âge, votre sexe et votre état de santé. Elle couvre toutes les vitamines nécessaires, notamment les vitamines <strong>A, C, D, E, K</strong> et toutes les vitamines du <strong>complexe B</strong>, avec des informations détaillées sur les bienfaits et les sources de chaque vitamine.
            </p>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-6 calculatorStyle">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Calculez vos besoins quotidiens</h2>
              </div>
              <form onSubmit={handleCalculate}>
                <div className="form-group mb-3">
                  <label htmlFor="vitamin"><strong>Choisissez la vitamine :</strong></label>
                  <select className="form-control" id="vitamin" value={selectedVitamin} onChange={(e) => setSelectedVitamin(e.target.value)}>
                    {Object.keys(vitaminsList).map((key) => (
                      <option key={key} value={key}>{vitaminsList[key]}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="age"><strong>Âge (en années) :</strong></label>
                  <input type="number" className="form-control" id="age" value={age} onChange={(e) => setAge(e.target.value)} placeholder="Entrez votre âge" min="0" max="120" required />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="sex"><strong>Sexe :</strong></label>
                  <select className="form-control" id="sex" value={sex} onChange={(e) => { setSex(e.target.value); if (e.target.value === "male") { setIsPregnant(false); setIsLactating(false); } }}>
                    <option value="male">Homme</option>
                    <option value="female">Femme</option>
                  </select>
                </div>
                {sex === "female" && (
                  <>
                    <div className="form-group mb-3">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="pregnant" checked={isPregnant} onChange={(e) => { setIsPregnant(e.target.checked); if (e.target.checked) setIsLactating(false); }} />
                        <label className="form-check-label" htmlFor="pregnant">Enceinte</label>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="lactating" checked={isLactating} onChange={(e) => { setIsLactating(e.target.checked); if (e.target.checked) setIsPregnant(false); }} />
                        <label className="form-check-label" htmlFor="lactating">Allaitante</label>
                      </div>
                    </div>
                  </>
                )}
                <hr />
                <div className="d-flex gap-2">
                  <button type="submit" className="btn bg-success text-white" style={{ fontSize: "16px", padding: "10px 30px" }}>Calculer</button>
                  <button type="button" className="btn btn-secondary" onClick={handleReset} style={{ fontSize: "16px", padding: "10px 30px" }}>Réinitialiser</button>
                </div>
              </form>
            </div>
            <div className="col-sm-12 col-md-4">
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>Erreur :</strong> {error}
                </div>
              )}
              {dose !== null && !error && (
                <div className="calculatorStyle">
                  <div className="p-3 mb-3 bg-success text-white text-center rounded">
                    <h3 style={{ fontSize: "18px", margin: 0 }}>Résultat</h3>
                  </div>
                  <div className="alert alert-success" style={{ fontSize: "16px", lineHeight: "1.8" }}>
                    <h4 style={{ fontSize: "17px", marginBottom: "15px" }}>Dose quotidienne recommandée :</h4>
                    <div style={{ textAlign: "center", padding: "20px", backgroundColor: "#d4edda", borderRadius: "8px", marginBottom: "15px" }}>
                      <div style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>{vitaminsList[selectedVitamin]}</strong>
                      </div>
                      <div style={{ fontSize: "32px", fontWeight: "bold", color: "#155724" }}>
                        {dose} {vitaminUnits[selectedVitamin]}
                      </div>
                    </div>
                    <div style={{ fontSize: "14px", marginTop: "15px" }}>
                      <strong>Remarque :</strong>
                      <ul style={{ marginTop: "10px", lineHeight: "1.6" }}>
                        <li>Cette dose représente l'apport journalier recommandé (AJR)</li>
                        <li>Vos besoins réels peuvent varier selon votre état de santé et votre alimentation</li>
                        <li>Consultez votre médecin avant de prendre des compléments alimentaires</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              <SecondAds />
            </div>
          </div>
          <hr />
          <div className="alert alert-info" style={{ fontSize: "15px", lineHeight: "1.8" }}>
            <strong>💡 Information importante :</strong> Les résultats sont basés sur les apports journaliers recommandés (AJR) des instituts nationaux de santé américains. Des doses plus élevées peuvent être nécessaires dans certains cas selon l'avis de votre médecin.
          </div>
        </div>
        <br />
        {/* Vitamins Table */}
        <div className="border border-light p-3 bg-white shadow-sm">
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>Calculez la dose quotidienne pour chaque vitamine</h2>
          <table className="table table-bordered table-hover">
            <thead>
              <tr style={{ backgroundColor: "#e7f3fe" }}>
                <th style={{ textAlign: "center", padding: "12px" }}>Nom de la vitamine</th>
                <th style={{ textAlign: "center", padding: "12px" }}>Calculer la dose quotidienne</th>
              </tr>
            </thead>
            <tbody>
              {[
                { name: "Vitamine A", path: "a" },
                { name: "Vitamine C", path: "c" },
                { name: "Vitamine D", path: "d" },
                { name: "Vitamine E", path: "e" },
                { name: "Vitamine K", path: "k" },
                { name: "Thiamine (B1)", path: "b1" },
                { name: "Riboflavine (B2)", path: "b2" },
                { name: "Niacine (B3)", path: "b3" },
                { name: "Acide pantothénique (B5)", path: "b5" },
                { name: "Pyridoxine (B6)", path: "b6" },
                { name: "Biotine (B7)", path: "b7" },
                { name: "Acide folique (B9)", path: "b9" },
                { name: "Cobalamine (B12)", path: "b12" },
                { name: "Choline", path: "choline" },
              ].map((v) => (
                <tr key={v.path}>
                  <td style={{ padding: "10px" }}>{v.name}</td>
                  <td style={{ padding: "10px" }}>
                    <a href={`/calculator/fr/vitamin-daily-dose/${v.path}/`}>Calculer la dose quotidienne de {v.name}</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        {/* Educational Content */}
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="info-sections-container">
              <div className="info-section">
                <div className="info-section-header">
                  <strong>Guide complet des vitamines essentielles</strong>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>
                    Les <strong>vitamines</strong> sont des composés organiques essentiels dont l'organisme a besoin en petites quantités pour une croissance normale et le maintien de la santé. La plupart des vitamines ne peuvent pas être produites par l'organisme et doivent être obtenues par l'alimentation ou des compléments.
                  </p>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Classification des vitamines :</h3>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}><strong>1. Vitamines liposolubles :</strong></h4>
                  <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                    <ul style={{ marginTop: "10px" }}>
                      <li><strong>Vitamine A :</strong> stockée dans le foie, importante pour la vision et l'immunité</li>
                      <li><strong>Vitamine D :</strong> produite par l'organisme lors de l'exposition au soleil, essentielle pour les os</li>
                      <li><strong>Vitamine E :</strong> puissant antioxydant, protège les cellules</li>
                      <li><strong>Vitamine K :</strong> essentielle pour la coagulation du sang et la santé osseuse</li>
                    </ul>
                    <br />
                    <strong>Remarque :</strong> Ces vitamines sont stockées dans l'organisme, donc un excès peut causer des problèmes de santé.
                  </div>
                  <h4 style={{ fontSize: "16px", marginTop: "15px" }}><strong>2. Vitamines hydrosolubles :</strong></h4>
                  <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                    <ul style={{ marginTop: "10px" }}>
                      <li><strong>Vitamine C :</strong> antioxydant, renforce l'immunité, aide à l'absorption du fer</li>
                      <li><strong>Vitamines du complexe B (8 types) :</strong> essentielles pour la production d'énergie et le système nerveux</li>
                    </ul>
                    <br />
                    <strong>Remarque :</strong> Ne sont pas stockées dans l'organisme, donc doivent être consommées quotidiennement.
                  </div>
                  <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Importance des vitamines :</h3>
                  <ol style={{ lineHeight: "1.8" }}>
                    <li><strong>Production d'énergie :</strong> les vitamines B aident à convertir les aliments en énergie</li>
                    <li><strong>Renforcement de l'immunité :</strong> les vitamines C, D, A protègent contre les maladies</li>
                    <li><strong>Santé osseuse :</strong> les vitamines D, K, C sont essentielles pour des os solides</li>
                    <li><strong>Santé de la peau :</strong> les vitamines A, C, E maintiennent la fraîcheur du teint</li>
                    <li><strong>Prévention des maladies chroniques :</strong> les antioxydants protègent contre le cancer et les maladies cardiaques</li>
                  </ol>
                  <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                    <strong>⚠️ Avertissement :</strong> Malgré l'importance des vitamines, un excès peut être nocif. Respectez les doses recommandées et consultez votre médecin avant de prendre des compléments.
                  </div>
                </div>
              </div>
              <div className="info-section">
                <div className="info-section-header">
                  <strong>Sources naturelles de vitamines</strong>
                </div>
                <div className="info-section-body">
                  <p style={{ lineHeight: "1.8" }}>La meilleure façon d'obtenir des vitamines est par une <strong>alimentation équilibrée et variée</strong>. Voici les principales sources naturelles de chaque vitamine :</p>
                  <div style={{ lineHeight: "1.8", marginTop: "15px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                    <h4 style={{ fontSize: "16px", color: "#198754" }}><strong>Vitamine A :</strong></h4>
                    <ul>
                      <li>Carottes, patates douces, citrouilles</li>
                      <li>Épinards, chou, brocoli</li>
                      <li>Foie, œufs, lait</li>
                      <li>Mangues, abricots, melon</li>
                    </ul>
                  </div>
                  <div style={{ lineHeight: "1.8", marginTop: "15px", padding: "15px", backgroundColor: "#fff3cd", borderRadius: "8px" }}>
                    <h4 style={{ fontSize: "16px", color: "#856404" }}><strong>Vitamine C :</strong></h4>
                    <ul>
                      <li>Agrumes (orange, citron, pamplemousse)</li>
                      <li>Poivrons (de couleur)</li>
                      <li>Fraises, kiwi, goyave</li>
                      <li>Brocoli, tomates</li>
                    </ul>
                  </div>
                  <div style={{ lineHeight: "1.8", marginTop: "15px", padding: "15px", backgroundColor: "#d1ecf1", borderRadius: "8px" }}>
                    <h4 style={{ fontSize: "16px", color: "#0c5460" }}><strong>Vitamine D :</strong></h4>
                    <ul>
                      <li><strong>Rayons du soleil :</strong> 10-30 minutes par jour (source principale)</li>
                      <li>Poissons gras (saumon, thon, sardines)</li>
                      <li>Jaune d'œuf</li>
                      <li>Lait et aliments enrichis en vitamine D</li>
                    </ul>
                  </div>
                  <div style={{ lineHeight: "1.8", marginTop: "15px", padding: "15px", backgroundColor: "#d4edda", borderRadius: "8px" }}>
                    <h4 style={{ fontSize: "16px", color: "#155724" }}><strong>Vitamine E :</strong></h4>
                    <ul>
                      <li>Noix (amandes, noisettes, cacahuètes)</li>
                      <li>Graines (tournesol, citrouille)</li>
                      <li>Huiles végétales (olive, tournesol)</li>
                      <li>Épinards, brocoli, avocat</li>
                    </ul>
                  </div>
                  <div style={{ lineHeight: "1.8", marginTop: "15px", padding: "15px", backgroundColor: "#f8d7da", borderRadius: "8px" }}>
                    <h4 style={{ fontSize: "16px", color: "#721c24" }}><strong>Vitamines du complexe B :</strong></h4>
                    <ul>
                      <li>Céréales complètes et aliments enrichis</li>
                      <li>Viandes, foie, poissons, œufs</li>
                      <li>Légumineuses (lentilles, haricots)</li>
                      <li>Légumes verts à feuilles, avocats</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VitaminDailyDoseCalculator;
